import useToggleModal from "hooks/useToggleModal";
import ConfirmModal from "components/confirm-modal";
import React, { createContext, ReactNode, useContext, useState } from "react";

type Context = {
  openInvoicingModal: (arg: { appointment }) => void;
  closeInvoicingModal: () => void;
};
const InvoicingModalContext = createContext<Context>({
  openInvoicingModal: () => null,
  closeInvoicingModal: () => null,
});

type Props = { children: ReactNode };

export const InvoicingModalContextProvider = ({ children }: Props) => {
  const {
    open: openInvoicingModal,
    close: closeInvoicingModal,
    show,
  } = useToggleModal(false);

  const [appointment, setAppointment] = useState<AppointmentWithSeriesInfo>();

  const handleOpen = ({
    appointment,
  }: {
    appointment: AppointmentWithSeriesInfo;
  }) => {
    setAppointment(appointment);
    openInvoicingModal();
  };

  const handleClose = () => {
    closeInvoicingModal();
  };

  return (
    <>
      <InvoicingModalContext.Provider
        value={{
          openInvoicingModal: handleOpen,
          closeInvoicingModal: handleClose,
        }}
      >
        {children}
      </InvoicingModalContext.Provider>
      {appointment && (
        <ConfirmModal
          labelTitle={"Cancel session?"}
          children={
            "If you cancel the session, all invoices created will be void, and the session will no longer available for the patients. Do you want to continue?"
          }
          labelCancel={"No, don't"}
          labelConfirm={"Yes, Cancel"}
          show={show}
          onCancel={() => handleClose()}
          //   onConfirm={() => onStatusChange()}
          onConfirm={() => null}
        />
      )}
    </>
  );
};

export const useInvoicingModalContext = () => useContext(InvoicingModalContext);
